import { ActionTypes, ReduxAction } from './types';
import { Dispatch } from 'redux';
import { History } from 'history';
import { Auftrag, AuftragService, BenutzerService } from '../../api';
import { setNotification } from '../../utils/notificationUtils';
import { ServiceModel } from '../../models/ServiceModel';
import { AuftragPositionModel } from '../../models/AuftragPositionModel';
import { isoDateToDate, nextWorkingDay } from '../../utils/date';
import store from '../store';
import { ConfigModel } from '../../models/ConfigModel';
import { WaehrungModel } from '../../models/WaehrungModel';

export const saveAuftrag =
  (auftrag: Auftrag, onSaveSuccess: () => void) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    new AuftragService().createAuftrag(auftrag).then(response => {
      const auftrag = response.data;
      dispatch({
        type: ActionTypes.SAVE_AUFTRAG,
        payload: auftrag,
      });
      setNotification(
        'Der Auftrag ' +
          auftrag.spedeigennr +
          ' wurde erfolgreich gespeichert.',
        []
      );
      const configState: ConfigModel = store.getState().Config;

      dispatch({
        type: ActionTypes.RESET_AUFTRAGSERFASSUNG,
        payload: configState,
      });
      dispatch({
        type: ActionTypes.SET_ACTIVE_TAB,
        payload: 'auftragsresearch',
      });
      dispatch({
        type: ActionTypes.SET_BELADEDATUM,
        payload: configState.isBeladedatumVorbelegen ? new Date() : '',
      });
      dispatch({
        type: ActionTypes.SET_ENTLADEDATUM,
        payload: configState.isEntladedatumVorbelegen ? nextWorkingDay() : '',
      });
      onSaveSuccess();
    });
  };

export const updateAuftrag =
  (
    auftragId: number,
    auftrag: Auftrag,
    onSaveSuccess: () => void,
    history: History
  ) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    new AuftragService().update1(auftragId, auftrag).then(response => {
      const auftrag = response.data;
      dispatch({
        type: ActionTypes.UPDATE_AUFTRAG,
        payload: auftrag,
      });
      setNotification(
        'Der Auftrag ' +
          auftrag.spedeigennr +
          ' wurde erfolgreich aktualisiert.',
        []
      );

      dispatch({
        type: ActionTypes.SET_ACTIVE_TAB,
        payload: 'auftragsresearch',
      });

      dispatch({
        type: ActionTypes.SET_BELADEDATUM,
        payload: isoDateToDate(new Date()),
      });

      dispatch({
        type: ActionTypes.SET_ENTLADEDATUM,
        payload: nextWorkingDay(),
      });
      history.push('/auftragsmanagement/auftragsresearch');
      const configState: ConfigModel = store.getState().Config;

      dispatch({
        type: ActionTypes.RESET_AUFTRAGSERFASSUNG,
        payload: configState,
      });
      onSaveSuccess();
    });
  };

export const setAuftragId =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_AUFTRAG_ID,
      payload: value,
    });
  };

export const setTerminkennzeichen =
  (value: number | undefined) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_TERMINKENNZEICHEN,
      payload: value,
    });
  };

export const setZustellkennzeichen =
  (value: number | undefined) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_ZUSTELLKENNZEICHEN,
      payload: value,
    });
  };

export const setAnlieferkennzeichen =
  (value: number | undefined) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_ANLIEFERKENNZEICHEN,
      payload: value,
    });
  };

export const setFrankatur =
  (value: number | undefined) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_FRANKATUR,
      payload: value,
    });
  };

export const setAuftragField =
  (value: any, fieldName: string) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_AUFTRAG_FIELD,
      payload: { value: value, fieldName: fieldName },
    });
  };
export const setVerkehrsart =
  (value: number | undefined) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_VERKEHRSART,
      payload: value,
    });
  };

export const setMetrokennung =
  (value: number | undefined) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_METROKENNUNG,
      payload: value,
    });
  };

export const setSperrigkeit =
  (value: number | undefined) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_SPERRIGKEIT,
      payload: value,
    });
  };

export const setBeladedatum =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_BELADEDATUM,
      payload: value,
    });
  };

export const setBeladezeitVon =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_BELADEZEIT_VON,
      payload: value,
    });
  };

export const setAbwBeladung =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_ABWEICHENDE_BELADUNG,
      payload: value,
    });
  };
export const setIsAbwBeladeAdresseSet =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_IS_ABWEICHENDE_BELADEADRESSE,
      payload: value,
    });
  };

export const setIsNeutralerAbsenderSet =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_IS_NEUTRALER_ABSENDER_SET,
      payload: value,
    });
  };

export const setBeladezeitBis =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_BELADEZEIT_BIS,
      payload: value,
    });
  };

export const setEmpfaengerreferenz =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_EMPFAENGERREFERENZ,
      payload: value,
    });
  };

export const setEntladedatum =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_ENTLADEDATUM,
      payload: value,
    });
  };

export const setEntladezeitVon =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_ENTLADEZEIT_VON,
      payload: value,
    });
  };

export const setEntladezeitBis =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_ENTLADEZEIT_BIS,
      payload: value,
    });
  };

export const setAbsenderreferenz =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_ABSENDERREFERENZ,
      payload: value,
    });
  };

export const setIban =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_IBAN,
      payload: value,
    });
  };

export const setBic =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_BIC,
      payload: value,
    });
  };

export const setNachnahmebetrag =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_NACHNAHMEBETRAG,
      payload: value,
    });
  };

export const setNachnahmebetragWaehrung =
  (value: WaehrungModel | undefined) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_NACHNAHMEBETRAG_WAEHRUNG,
      payload: value,
    });
  };

export const setTausch_A =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_TAUSCH_A,
      payload: value,
    });
  };
export const setTausch_B =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_TAUSCH_B,
      payload: value,
    });
  };
export const setTausch_R =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_TAUSCH_R,
      payload: value,
    });
  };
export const setTausch_Y =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_TAUSCH_Y,
      payload: value,
    });
  };
export const setHinweis =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_HINWEIS,
      payload: value,
    });
  };
export const setDispohinweis =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_DISPOHINWEIS,
      payload: value,
    });
  };
export const setZollvermerk =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_ZOLLVERMERK,
      payload: value,
    });
  };
export const setCurrentAuftragpos =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_CURRENT_AUFTRAGPOS,
      payload: value,
    });
  };

export const setAdresse =
  (addressType: string, value: string | number | null, fieldName: string) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_ADRESSE,
      payload: { value: value, fieldName: fieldName, addressType: addressType },
    });
  };

export const setCurrentAuftragsgefahrgueter =
  (auftragsgefahrgueter: any[], auftragsPosRowIndex: number) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_CURRENT_AUFTRAGSGEFAHRGUETER,
      payload: {
        auftragsgefahrgueter: auftragsgefahrgueter,
        auftragsPosRowIndex: auftragsPosRowIndex,
      },
    });
  };

export const setCurrentServices =
  (services: ServiceModel[]) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_CURRENT_SERVICES,
      payload: services,
    });
  };

/*export const setCurrentTerminkennzeichen =
  (terminkennzeichen: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_CURRENT_TERMINKENNZEICHEN,
      payload: terminkennzeichen,
    });
  };*/

export const setCurrentControlling =
  (value: any, fieldName: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_CURRENT_CONTROLLING,
      payload: { value: value, fieldName: fieldName },
    });
  };

export const setCurrentAuftragspositionen =
  (auftragspositionen: AuftragPositionModel[]) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_CURRENT_AUFTRAGPOS,
      payload: auftragspositionen,
    });
  };

export const setCurrentZusLademittel =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_CURRENT_ZUSLADEMITTEL,
      payload: value,
    });
  };

export const setAuftragServices =  //#84357
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_AUFTRAG_SERVICES,
      payload: value,
    });
  };

export const resetAuftragserfassung =
  (history?: History) => async (dispatch: Dispatch<ReduxAction>) => {
    const configState: ConfigModel = store.getState().Config;

    dispatch({
      type: ActionTypes.RESET_AUFTRAGSERFASSUNG,
      payload: configState,
    });
    dispatch({
      type: ActionTypes.REMOVE_NOTIFICATIONS,
    });
    if (history) {
      history.goBack();
    }
  };

export const getAuftragById =
  (id: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new AuftragService().getAuftragById(id).then(response => {
      const config: ConfigModel = store.getState().Config;

      dispatch({
        type: ActionTypes.GET_AUFTRAG,
        payload: {
          auftrag: response.data,
          config: config,
        },
      });
    });
  };

export const getAuftragByVorlageAuftragId =
  (id: number) => async (dispatch: Dispatch<ReduxAction>) => {
    const config: ConfigModel = store.getState().Config;

    new AuftragService().getAuftragVorlageById(id).then(response => {
      dispatch({
        type: ActionTypes.COPY_AUFTRAG,
        payload: {
          auftrag: response.data,
          config: config,
        },
      });
      dispatch({
        type: ActionTypes.SET_VORLAGE_AUFTRAG_ID,
        payload: id,
      });
    });
  };

export const getAuftragCopyByAuftragId =
  (id: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new AuftragService().getAuftragById(id).then(response => {
      const config: ConfigModel = store.getState().Config;

      dispatch({
        type: ActionTypes.COPY_AUFTRAG,
        payload: {
          auftrag: response.data,
          config: config,
        },
      });
      dispatch({
        type: ActionTypes.SET_AUFTRAG_KOPIE_ID,
        payload: id,
      });
    });
  };

export const getCurrentBenutzerById =
  (id: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new BenutzerService().getBenutzerById(id).then(response => {
      dispatch({
        type: ActionTypes.GET_CURRENT_BENUTZER,
        payload: response.data,
      });
    });
  };
export const setAuftragKopieId =
  (id: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_AUFTRAG_KOPIE_ID,
      payload: id,
    });
  };

export const setSpotpreisnr =
  (value: any) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_SPOTPREISNR,
      payload: value,
    });
  };
